import styled from 'styled-components';

export const HeaderNavigationName = ({ name }) => {
  if (name?.includes('[date]')) {
    const itemInfo = name?.split('[date]');

    return (
      <HeaderNavigationName.ChildContainer>
        <HeaderNavigationName.ChildDate>{itemInfo?.[1]}</HeaderNavigationName.ChildDate>
        <span>{itemInfo?.[2]}</span>
      </HeaderNavigationName.ChildContainer>
    );
  }

  return name;
};

HeaderNavigationName.ChildContainer = styled.div`
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 245px;
`;

HeaderNavigationName.ChildDate = styled.span`
  min-width: 40px;
  width: 40px;
  margin-right: 4px;
  display: inline-block;
`;
